import React from 'react';
import styled from 'styled-components';
import { formatFullDateTime, formatRelativeTime } from '../../helpers/utils';
import { type ThemeConfig, useTheme } from '../../theme';
import type { UserMessage } from '../../types';

interface UserMessageBubbleProps {
  message: UserMessage;
}

const UserMessageBubble: React.FC<UserMessageBubbleProps> = ({ message }) => {
  const theme = useTheme();

  return (
    <Wrapper $theme={theme}>
      <Bubble $theme={theme}>{message.content}</Bubble>
      {message.created_at && (
        <Timestamp $theme={theme} title={formatFullDateTime(message.created_at)}>
          {formatRelativeTime(message.created_at)}
        </Timestamp>
      )}
    </Wrapper>
  );
};

// Styled Components
const Wrapper = styled.div<{ $theme: ThemeConfig }>`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: ${(props) => props.$theme.tokens.spaceMd};
`;

const Bubble = styled.div<{ $theme: any }>`
  background-color: ${(props) => props.$theme.colors.userBubbleBg};
  color: ${(props) => props.$theme.colors.userBubbleText};
  font-weight: 500;
  padding: 18px 24px;
  border-radius: ${(props) => props.$theme.tokens.radiusMd};
  max-width: 70%;
  word-wrap: break-word;
  font-size: 16px;
  line-height: 1.5;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  /* Responsive adjustments */
  @media (max-width: 768px) {
    max-width: 85%;
    padding: 16px 20px;
    font-size: 15px;
  }

  @media (max-width: 480px) {
    max-width: 100%;
    padding: 14px 18px;
    font-size: 14px;
    border-radius: 16px;
  }
`;

const Timestamp = styled.div<{ $theme: any }>`
  font-size: 12px;
  color: ${(props) => props.$theme.colors.sidebarGroupColor};
  opacity: 0.5;
  margin-top: 4px;
  margin-right: 8px;
`;

export default UserMessageBubble;
